import RuUtils from "./regional/RuUtils";
import UzUtils from "./regional/UzUtils";
import EnUtils from "./regional/EnUtils";
import ByUtils from "./regional/ByUtils";
import CnUtils from "./regional/CnUtils";
import DeUtils from "./regional/DeUtils";
import EsUtils from "./regional/EsUtils";
import GbUtils from "./regional/GbUtils";
import ChUtils from "./regional/ChUtils";
import InUtils from "./regional/InUtils";
import PlUtils from "./regional/PlUtils";
import KzUtils from "./regional/KzUtils";
import TrUtils from "./regional/TrUtils";

class RegionalUtils {
  
  static get ru() {
    return RuUtils;
  }
  
  static get uz() {
    return UzUtils;
  }
  
  static get en() {
    return EnUtils;
  }
  
  static get by() {
    return ByUtils;
  }
  
  static get cn() {
    return CnUtils;
  }
  
  static get de() {
    return DeUtils;
  }
  
  static get es() {
    return EsUtils;
  }
  
  static get gb() {
    return GbUtils;
  }
  
  static get ch() {
    return ChUtils;
  }
  
  static get in() {
    return InUtils;
  }
  
  static get pl() {
    return PlUtils;
  }
  
  static get kz() {
    return KzUtils;
  }
  
  static get tr() {
    return TrUtils;
  }
}

export default RegionalUtils;